import React from 'react'
import PropTypes from 'prop-types'

import styles from './index.css'

export default function (props) {
  return (
    <div className={styles.ManageButton} {...props}>
      <svg xmlns="http://www.w3.org/2000/svg" width="12" height="16" viewBox="0 0 12 16">
          <g fill="none" fillRule="evenodd">
              <path d="M-4-2h20v20H-4z"/>
              <path fill="#34ADFA" d="M.766 14.785c0 .671.525 1.215 1.172 1.215h8.125c.647 0 1.17-.544 1.17-1.215V3.727H.766v11.058zM9.355 1.43V.233c0-.13-.1-.233-.225-.233H2.87a.229.229 0 0 0-.225.233V1.43H0v1.167h12V1.43H9.355z"/>
          </g>
      </svg>
      Delete 
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/buttons/DeleteButton/index.jsx